// F1 Seasons Page
import React from 'react';
import { useF1Championship } from '../../hooks/useF1Championship';
import F1PageTemplate from '../../components/f1/F1PageTemplate';
import { seasonsConfig } from '../../components/f1/SeasonsComponent';
import SeasonsComponent from '../../components/f1/SeasonsComponent';

const F1SeasonsPage = () => {
  const { data } = useF1Championship();

  const stats = seasonsConfig.stats.map(stat => ({
    ...stat,
    value: typeof stat.value === 'function' ? stat.value(data) : stat.value
  }));

  return (
    <F1PageTemplate
      title={seasonsConfig.title}
      subtitle={seasonsConfig.subtitle}
      summary={seasonsConfig.summary}
      stats={stats}
    >
      <SeasonsComponent data={data} />
    </F1PageTemplate>
  );
};

export default F1SeasonsPage;
